import { Pipe, PipeTransform } from '@angular/core';

const AMBER = 'bg-amber-50 dark:bg-amber-950/40 text-amber-600 dark:text-amber-400 border-amber-100 dark:border-amber-900';
const EMERALD = 'bg-emerald-50 dark:bg-emerald-950/40 text-emerald-600 dark:text-emerald-400 border-emerald-100 dark:border-emerald-900';
const PURPLE = 'bg-purple-50 dark:bg-purple-950/40 text-purple-600 dark:text-purple-400 border-purple-100 dark:border-purple-900';
const BLUE = 'bg-blue-50 dark:bg-blue-950/40 text-blue-600 dark:text-blue-400 border-blue-100 dark:border-blue-900';
const ROSE = 'bg-rose-50 dark:bg-rose-950/40 text-rose-600 dark:text-rose-400 border-rose-100 dark:border-rose-900';
const SLATE = 'bg-slate-50 dark:bg-slate-800/60 text-slate-500 dark:text-slate-400 border-slate-200 dark:border-slate-700';

const STATUS_STYLES: Record<string, string> = {
  PENDING_APPROVAL: AMBER,
  APPROVED: EMERALD,
  ACCEPTED: EMERALD,
  ACTIVE: EMERALD,
  COUNTERED: PURPLE,
  COMPLETED: PURPLE,
  PROCESSING: BLUE,
  PENDING_DISBURSEMENT: BLUE,
  DISBURSED: BLUE,
  REJECTED: ROSE,
  DEFAULTED: ROSE,
  CANCELLED: ROSE,
  COUNTER_REJECTED: ROSE,
};

const STATUS_LABELS: Record<string, string> = {
  PENDING_APPROVAL: 'Pending',
  APPROVED:         'Approved',
  ACCEPTED:         'Accepted',
  ACTIVE:           'Active',
  COUNTERED:        'Countered',
  COMPLETED:        'Completed',
  PROCESSING:           'Processing',
  PENDING_DISBURSEMENT: 'Pending Disbursement',
  DISBURSED:            'Disbursed',
  REJECTED:         'Rejected',
  DEFAULTED:        'Defaulted',
  CANCELLED:        'Cancelled',
  COUNTER_REJECTED: 'Ctr. Rejected',
};

@Pipe({ name: 'loanStatusStyle', standalone: true })
export class LoanStatusStylePipe implements PipeTransform {
  transform(status: string | null | undefined): string {
    return STATUS_STYLES[status ?? ''] ?? SLATE;
  }
}

@Pipe({ name: 'loanStatusLabel', standalone: true })
export class LoanStatusLabelPipe implements PipeTransform {
  transform(status: string | null | undefined): string {
    return STATUS_LABELS[status ?? ''] ?? status ?? '—';
  }
}
